<template>
	<vs-prompt
		@accept="setNewPriceForJuniorAndMiddle"
		:active.sync="popupActive"
		:title="$t('newPriceForJuniorAndMiddle')"
		:acceptText="$t('save')"
		:cancelText="$t('cancel')"
		class="add-order-task"
	>
		<div>
            <vs-input
                :label="$t('priceForJuniorAndMiddle')"
                v-model="newPriceInput"
                v-validate="'required'"
            />
		</div>
	</vs-prompt>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";

export default {
	name: "NewPriceJMPopupActive",
	mixins: [databaseManager, notifier],
	props: {
		active: { required: true, type: Boolean },
		orderMilestone: { required: true },
	},
    data() {
		return {
            newPriceInput: "",
		}
	},
	watch: {
		popupActive(value) {
			if(value) return;
		}
	},
	computed: {
		popupActive: {
			get() {
				return this.active;
			},
			set(newValue) {
				this.$emit("update:active", newValue);
			}
		},
	},
	methods: {
		async setNewPriceForJuniorAndMiddle() {
			this.popupActive = true;

			try {
				let newPrice = null;

                newPrice = await this.dbNewPriceJMPopupActive(this.orderMilestone.id, this.newPriceInput);
                this.orderMilestone.price_junior_middle = this.newPriceInput;
				this.newPriceInput = '';

				this.popupActive = false;

				this.notifySuccess(this.$t('setPriceSuccessfully'));

                this.$emit('changeStage', {
                        stage: this.orderMilestone
                    });

			} catch (e) {
				this.notifyError(e.message)
			}
		},
	},
    created() {
        this.newPriceInput = this.orderMilestone.price_junior_middle;
    }
};
</script>

<style lang="scss">
.add-order-task {
	.append-text {
		height: 2.7rem;
	}

	.vs-button {
		border-left: 0;
	}

	.vx-input-group-append {
		align-items: flex-end;
	}

	.vs-input {
		width: 100%;

		textarea {
			resize: none;
		}
	}
}
</style>
